export default {
  state: {
    apps: [],
    selectedApp: null,
  },
  getters: {
    "nlp/apps/query": (state) => (query) => {
      const fallback = [];
      if (!state.apps || !state.apps.length) return fallback;
      const result = state.apps.filter(
        (app) =>
          app.name.toLowerCase().includes(query.toLowerCase()) ||
          app.culture.toLowerCase().includes(query.toLowerCase())
      );
      return result && result.length ? result.reverse() : fallback;
    },
  },
  mutations: {
    "nlp/apps/add": function (state, data) {
      state.apps.splice(0, 0, data);
    },
    "nlp/apps/set": function (state, data) {
      state.apps = data;
    },
    "nlp/apps/select": function (state, data) {
      state.selectedApp = data;
    },
  },
  actions: {
    "nlp/apps/get": async function ({ commit, dispatch }, payload) {
      try {
        dispatch("setLoader", true);
        const { data } = await this._vm.$http_nlp_bot.get("/apps");
        dispatch("setLoader", false);
        const { result } = data.data;
        commit("nlp/apps/set", result);
        return result;
      } catch (err) {
        dispatch("setLoader", false);
        commit("nlp/apps/set", []);
        throw new Error(err);
      }
    },
    "nlp/apps/get/current": async function (
      { commit, dispatch, state },
      payload
    ) {
      try {
        dispatch("setLoader", true);
        const { data } = await this._vm.$http_nlp.get(`/apps/${payload}`);
        dispatch("setLoader", false);
        const result = data.data;
        commit("nlp/apps/select", result);
        dispatch("nlp/versions/get");
        return result;
      } catch (err) {
        dispatch("setLoader", false);
        commit("nlp/apps/select", null);
        throw new Error(err);
      }
    },
    "nlp/apps/add": async function ({ commit, dispatch }, payload) {
      try {
        const { data } = await this._vm.$http_nlp.post("/apps", payload);
        dispatch("nlp/apps/get");
        return data;
      } catch (err) {
        throw new Error(err);
      }
    },
    "nlp/apps/update": async function ({ dispatch }, payload) {
      try {
        let request_payload = {
          name: payload.name,
          priority: payload.priority,
          min_score: payload.min_score,
          app_type: payload.app_type,
        };

        const { data } = await this._vm.$http_nlp.put(
          `/apps/${payload.id}`,
          request_payload
        );
        dispatch("nlp/apps/get");
        return data;
      } catch (err) {
        throw new Error(err);
      }
    },
    "nlp/apps/delete": async function ({}, id) {
      try {
        await this._vm.$http_nlp.delete(`/apps/${id}`);
        return true;
      } catch (err) {
        throw err;
      }
    },
    "nlp/apps/publish": async function ({ dispatch, state }) {
      try {
        dispatch("setLoader", true);
        await this._vm.$http_nlp.post(`/apps/${state.selectedApp.id}/publish`);
        dispatch("setLoader", false);
        return true;
      } catch (err) {
        if (err.response.status === 400) {
          throw new Error(`You must train your app first`);
        } else {
          throw err;
        }
      }
    },
    "nlp/apps/delete/single": async function ({ dispatch }, id) {
      try {
        await this._vm.$http_nlp.delete(`/apps/${id}`);
        dispatch("nlp/apps/get");
        return true;
      } catch (err) {
        throw err;
      }
    },
    "nlp/apps/sync/single": async function ({ dispatch }, id) {
      try {
        await this._vm.$http_nlp.post(`/apps/${id}/sync`);
        dispatch("nlp/apps/get");
        return true;
      } catch (err) {
        throw err;
      }
    },
    "nlp/apps/delete/multiple": async function ({ dispatch }, payload) {
      try {
        dispatch("setLoader", true);
        let i;
        for (i = 0; i < payload.length; i += 1) {
          try {
            await dispatch("nlp/apps/delete/single", payload[i].id);
          } catch (err) {
            dispatch("setLoader", false);
            throw new Error(err);
          }
        }
        if (i === payload.length - 1) return dispatch("nlp/apps/get");
      } catch (err) {
        console.log(err);
        throw new Error(err);
      }
    },
    "nlp/apps/set": function ({ commit }, data) {
      commit("nlp/apps/set", data);
      return data;
    },
    "nlp/apps/select": function ({ commit, dispatch }, data) {
      commit("nlp/apps/select", data);
      dispatch("nlp/versions/get");
    },
  },
};
